<template>
    <div class="concept-page">
        <header class="concept-hero">
            <div class="concept-hero-content">
                <div class="hero-inner">
                    <h1 class="concept-title">Notre Concept</h1>
                </div>
            </div>
        </header>

        <main class="concept-container">
            <section class="concept-content">
                <div class="content-box">
                    <div class="concept-layout">
                        <div class="concept-text">
                            <p class="concept-paragraph">
                                MyEcoCar est une plateforme innovante basée sur une mise en relation sans commission. Les frais de voyage seront payés directement par le passager au conducteur.
                            </p>

                            <p class="concept-paragraph">
                                C'est une véritable communauté dont les membres sont unis par leur sensibilité aux problèmes liés à l'écologie et à la nécessité de développer un système basé sur l'économie sociale.
                            </p>
                        </div>

                        <div class="concept-image">
                            <img alt="Concept de communauté et d'écologie" data-ai-hint="community ecology" loading="lazy" decoding="async" data-nimg="fill" class="object-cover concept-img" src="https://picsum.photos/600/400" />
                        </div>
                    </div>
                </div>
            </section>
        </main>

        <footer class="footer-section">
            <div class="footer-container">
                <div class="footer-left">
                    <div class="footer-logo-section">
                        <img src="https://i.imgur.com/z198fac.png" alt="MyEcoCar Logo" class="footer-logo" />
                        <span class="footer-brand-name">MyEcoCar</span>
                    </div>
                    <div class="footer-social-links">
                        <a href="#" class="social-link" title="Facebook">
                            <i class="fa fa-facebook-f"></i>
                        </a>
                        <a href="#" class="social-link" title="Twitter">
                            <i class="fa fa-twitter"></i>
                        </a>
                        <a href="#" class="social-link" title="Instagram">
                            <i class="fa fa-instagram"></i>
                        </a>
                        <a href="#" class="social-link" title="LinkedIn">
                            <i class="fa fa-linkedin"></i>
                        </a>
                    </div>
                </div>

                <div class="footer-center">
                    <div class="footer-column">
                        <h4 class="footer-column-title">Infos</h4>
                        <ul class="footer-links">
                            <li><router-link :to="{ name: 'cgu' }">CGU</router-link></li>
                            <li><router-link :to="{ name: 'faq' }">FAQ</router-link></li>
                            <li><router-link :to="{ name: 'contact' }">Contact</router-link></li>
                        </ul>
                    </div>

                    <div class="footer-column">
                        <h4 class="footer-column-title">Decouvrir</h4>
                        <ul class="footer-links">
                            <li><router-link :to="{ name: 'about' }">Qui sommes-nous ?</router-link></li>
                            <li><router-link :to="{ name: 'conduct-charter' }">Charte de bonne conduite</router-link></li>
                            <li><router-link :to="{ name: 'map' }">Carte Interactive</router-link></li>
                        </ul>
                    </div>

                    <div class="footer-column">
                        <h4 class="footer-column-title">Plus</h4>
                        <ul class="footer-links">
                            <li><router-link :to="{ name: 'concept' }">Notre Concept</router-link></li>
                            <li><router-link :to="{ name: 'cookies' }">Utilisation des cookies</router-link></li>
                            <li><router-link :to="{ name: 'sitemap' }">Plan du site</router-link></li>
                        </ul>
                    </div>
                </div>
            </div>

            <div class="footer-bottom">
                <p class="footer-copyright">
                    &copy; {{ new Date().getFullYear() }} MyEcoCar. Tous les droits reserves.
                </p>
            </div>
        </footer>
    </div>
</template>

<script>
import router from '../../router';
import { bus } from '../../services/bus-event';

export default {
    name: 'Concept',
    created() {
        bus.$on('carpoolear:back', () => {
            router.back();
        });
    },
    beforeUnmount() {
        bus.$off('carpoolear:back');
    }
};
</script>

<style>
.app-container.concept,
.app-container.concept main,
.app-container.concept #main {
    min-height: 0 !important;
    margin-bottom: 0 !important;
    padding-bottom: 0 !important;
}

.app-container.concept .view-container {
    margin-bottom: 0 !important;
    padding-bottom: 0 !important;
}

.app-container.concept .footer-component {
    display: none !important;
}
</style>

<style scoped>
.concept-page {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    background: linear-gradient(to bottom, #f6f9f7, #ffffff);
    overflow-x: hidden;
}

/* Hero Section */
.concept-hero {
    background: linear-gradient(135deg, #1f3f2e 0%, #2d5016 100%);
    padding: 80px 20px;
    text-align: center;
    position: relative;
    overflow: hidden;
}

.concept-hero::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: 
        radial-gradient(circle at 20% 50%, rgba(174, 247, 185, 0.1) 0%, transparent 50%),
        radial-gradient(circle at 80% 50%, rgba(174, 247, 185, 0.1) 0%, transparent 50%);
    pointer-events: none;
}

.concept-hero-content {
    max-width: 1200px;
    margin: 0 auto;
    position: relative;
    z-index: 1;
}

.hero-inner {
    display: inline-block;
}

.concept-title {
    font-size: 3rem;
    font-weight: 700;
    color: #ffffff;
    margin: 0;
    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.2);
    letter-spacing: -0.5px;
}

/* Main Content */
.concept-container {
    flex: 1;
    display: flex;
    flex-direction: column;
}

.concept-content {
    max-width: 1400px;
    margin: 60px auto;
    padding: 0 20px;
    width: 100%;
}

.content-box {
    background: #ffffff;
    border-radius: 16px;
    padding: 60px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
}

.concept-layout {
    display: flex;
    align-items: center;
    gap: 60px;
}

.concept-text {
    flex: 1;
}

.concept-image {
    flex: 0 0 auto;
    width: 550px;
}

.concept-img {
    width: 100%;
    height: auto;
    border-radius: 12px;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
    transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.concept-img:hover {
    transform: translateY(-4px);
    box-shadow: 0 12px 32px rgba(0, 0, 0, 0.16);
}

.concept-paragraph {
    font-size: 1.125rem;
    line-height: 1.8;
    color: #2c3e50;
    margin: 0 0 24px 0;
    text-align: justify;
}

.concept-paragraph:last-child {
    margin-bottom: 0;
}

/* Footer Section */

.footer-section {
    background: linear-gradient(135deg, #1f3f2e 0%, #2d5016 100%);
    color: #ffffff;
    width: 100vw;
    margin-left: calc(-50vw + 50%);
    margin-right: calc(-50vw + 50%);
    margin-top: 2rem;
    margin-bottom: 0 !important;
    padding: 3rem 1rem 0;
}

.footer-container {
    max-width: 1200px;
    margin: 0 auto;
    display: grid;
    grid-template-columns: 0.8fr 1.2fr;
    gap: 3rem;
    align-items: start;
}

.footer-left {
    display: flex;
    flex-direction: column;
    gap: 2rem;
}

.footer-logo-section {
    display: flex;
    align-items: center;
    gap: 0.75rem;
}

.footer-logo {
    width: 50px;
    height: 50px;
    object-fit: contain;
}

.footer-brand-name {
    font-family: 'Poppins', sans-serif;
    font-size: 1.5rem;
    font-weight: 700;
    color: #aef7b9;
}

.footer-social-links {
    display: flex;
    gap: 1rem;
    align-items: center;
}

.social-link {
    width: 44px;
    height: 44px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.1);
    display: flex;
    align-items: center;
    justify-content: center;
    color: #aef7b9;
    text-decoration: none;
    transition: all 0.3s ease;
}

.social-link:hover {
    background: rgba(174, 247, 185, 0.2);
    color: #ffffff;
    transform: translateY(-3px);
}

.social-link i {
    font-size: 1.25rem;
}

.footer-center {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 2.5rem;
}

.footer-column {
    display: flex;
    flex-direction: column;
    gap: 1rem;
}

.footer-column-title {
    font-family: 'Poppins', sans-serif;
    font-size: 1.1rem;
    font-weight: 600;
    color: #aef7b9;
    margin: 0;
}

.footer-links {
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
}

.footer-links li {
    margin: 0;
}

.footer-links a {
    color: rgba(255, 255, 255, 0.8);
    text-decoration: none;
    font-family: 'Heebo', 'Poppins', sans-serif;
    font-size: 0.95rem;
    transition: color 0.3s ease;
}

.footer-links a:hover {
    color: #aef7b9;
    text-decoration: underline;
}

.footer-bottom {
    text-align: center;
    margin-top: 2rem;
    margin-bottom: 0;
    padding-top: 2rem;
    padding-bottom: 1.5rem;
    border-top: 1px solid rgba(174, 247, 185, 0.2);
    max-width: 1200px;
    margin-left: auto;
    margin-right: auto;
}

.footer-copyright {
    font-family: 'Heebo', 'Poppins', sans-serif;
    font-size: 0.9rem;
    color: rgba(255, 255, 255, 0.7);
    margin: 0;
}

/* Responsive Design */
@media (max-width: 1024px) {
    .concept-title {
        font-size: 2.5rem;
    }

    .content-box {
        padding: 40px;
    }

    .concept-layout {
        gap: 40px;
    }

    .concept-image {
        width: 500px;
    }

    .footer-container {
        grid-template-columns: 1fr;
        gap: 2rem;
    }

    .footer-center {
        grid-template-columns: repeat(3, 1fr);
        gap: 2rem;
    }
}

@media (max-width: 768px) {
    .concept-hero {
        padding: 60px 20px;
    }

    .concept-title {
        font-size: 2rem;
    }

    .concept-content {
        margin: 40px auto;
    }

    .content-box {
        padding: 30px;
    }

    .concept-layout {
        flex-direction: column;
        gap: 30px;
    }

    .concept-image {
        width: 100%;
    }

    .concept-paragraph {
        font-size: 1rem;
        text-align: left;
    }

    .footer-section {
        padding: 2rem 1rem 100px;
        margin-top: 1rem;
    }

    .footer-container {
        grid-template-columns: 1fr;
    }

    .footer-left {
        gap: 1.5rem;
    }

    .footer-center {
        grid-template-columns: 1fr;
        gap: 1.5rem;
    }

    .footer-column {
        gap: 0.75rem;
    }

    .footer-column-title {
        font-size: 1rem;
    }

    .footer-links a {
        font-size: 0.9rem;
    }

    .footer-logo {
        width: 40px;
        height: 40px;
    }

    .footer-brand-name {
        font-size: 1.25rem;
    }
}

@media (max-width: 480px) {
    .concept-title {
        font-size: 1.75rem;
    }

    .content-box {
        padding: 20px;
    }

    .concept-paragraph {
        font-size: 0.9375rem;
    }

    .footer-section {
        padding: 40px 20px 100px;
    }
}
</style>
